<script setup>
const props = defineProps({
  status: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <!-- Replace the three status <div>s with this block -->
  <Transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0 translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-1"
  >
    <div v-if="status" class="mt-6">
      <div
        class="relative flex items-start gap-3 rounded-iq-roundness border p-4 shadow-sm"
        :class="{
          'border-blue-200 bg-blue-50': status === 'loading',
          'border-green-200 bg-green-50': status === 'success',
          'border-red-200 bg-red-50': status === 'error',
        }"
        role="status"
        aria-live="polite"
      >
        <Icon
          v-if="status === 'loading'"
          name="i-heroicons-arrow-path-20-solid"
          class="mt-0.5 size-6 animate-spin text-blue-600"
        />
        <Icon
          v-else-if="status === 'success'"
          name="i-heroicons-check-circle-20-solid"
          class="mt-0.5 size-6 text-green-600"
        />
        <Icon
          v-else
          name="i-heroicons-exclamation-triangle-20-solid"
          class="mt-0.5 size-6 text-red-600"
        />

        <div class="flex-1">
          <p
            class="text-sm md:text-base font-medium"
            :class="{
              'text-blue-800': status === 'loading',
              'text-green-800': status === 'success',
              'text-red-800': status === 'error',
            }"
          >
            <template v-if="status === 'loading'">Wysyłanie…</template>
            <template v-else-if="status === 'success'"
              >Wiadomość została wysłana.</template
            >
            <template v-else>Wystąpił błąd podczas wysyłania wiadomości.</template>
          </p>

          <p v-if="status === 'error'" class="mt-1 text-sm text-red-700/80">
            Spróbuj ponownie lub zadzwoń:
            <a href="tel:+48604599773" class="underline hover:no-underline">604 599 773</a
            >.
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>
